import React from "react";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { Navigate } from "react-router-dom";

function withOutAuth<P extends object>(
  WrappedComponent: React.ComponentType<P>
): React.ComponentType<P> {
  const ComponentWithOutAuth = (props: P) => {
    const isAuthenticated = !!useAuthHeader();

    return isAuthenticated ? (
      <Navigate to="/" replace />
    ) : (
      <WrappedComponent {...props} />
    );
  };

  return ComponentWithOutAuth;
}

export default withOutAuth;
